"use strict";

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

(function () {
  "use strict";

  angular.module("schedules").controller("SchedulesCtrl", SchedulesCtrl);

  function SchedulesCtrl($state, $rootScope, $scope, $timeout, $controller, moment, AgGridService, CustomersService, CustomListsService, UsersService, SchedulesService, OperatorsService, ModalService, DepasService) {
    var _this = this;

    var vm = this;

    vm.ctrlName = "SchedulesCtrl";

    vm.activeTab = 'creneaux';

    vm.log = debug("pages:schedules");

    $controller("ListBaseController", {
      vm: vm,
      $scope: $scope,
      service: SchedulesService,
      params: {
        editPage: "schedules/schedule"
      }
    });

    vm.isLvr = ["super-admin", "super-operator", "operator"].indexOf($rootScope.$user.role) > -1 ? true : false;

    vm.isSuper = ["super-admin", "super-operator"].indexOf($rootScope.$user.role) > -1 ? true : false;

    vm.gridEvent = function (value) {
      console.log("gridEvent", value);
      if (value.type == "exportButton") {
        if (vm.runExport) {
          vm.runExport();
        }
      }
    };

    vm.runExport = function () {
      var sheets = [];

      var maxTab = 3;
      var currentTab = 0;
      while (currentTab < maxTab) {
        var sheet = vm.exportSheet[currentTab]();
        sheets.push(sheet);
        currentTab += 1;
      }

      vm.gridApi[0].exportMultipleSheetsAsExcel({
        data: sheets,
        fileName: "Créneaux"
      });
    };

    vm.gridReady = function (api, exportSheet, index) {
      if (!vm.gridApi) {
        vm.gridApi = {};
        vm.exportSheet = {};
      }
      vm.gridApi[index] = api;
      vm.exportSheet[index] = exportSheet;
    };

    vm.editClosedSlot = function (row) {
      ModalService.openComponent("closed-slot", { _id: row._id, size: "lg" }).then(function () {
        vm.refresh();
      }).catch(function (err) {
        console.log(err);
      });
    };

    vm.createClosedSlot = function () {
      ModalService.openComponent("closed-slot", { _id: null, size: "lg" }).then(function () {
        vm.refresh();
      }).catch(function (err) {
        console.log(err);
      });
    };

    vm.deleteClosedSlot = function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(row) {
        var start, end, deleteClosedSlot;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                start = moment(row.slot.start).format("DD/MM/YYYY à HH:mm");
                end = moment(row.slot.end).format("DD/MM/YYYY à HH:mm");
                _context.next = 4;
                return swal({
                  title: "Voulez-vous supprimer la p\xE9riode ferm\xE9e du " + start + " au " + end + " de " + row.operatorName + " ?",

                  icon: "warning",
                  dangerMode: true,

                  buttons: ["Annuler", "Valider"]
                });

              case 4:
                deleteClosedSlot = _context.sent;

                if (!deleteClosedSlot) {
                  _context.next = 16;
                  break;
                }

                _context.prev = 6;
                _context.next = 9;
                return DepasService.deleteById(row._id);

              case 9:
                Notiflix.Notify.success("La suppression a réussi");
                vm.refresh();
                _context.next = 16;
                break;

              case 13:
                _context.prev = 13;
                _context.t0 = _context["catch"](6);

                Notiflix.Notify.failure("La suppression a échoué");

              case 16:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, _this, [[6, 13]]);
      }));

      return function (_x) {
        return _ref.apply(this, arguments);
      };
    }();

    vm.refresh = function () {
      var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(params) {
        var customers, typesOfAccidentList, index, operator, disabledCustomers, enabledCustomers, allCustomers, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, _customer, schedules, holidays, bookedSlots, eventsArray, eventsSlotArray, _iteratorNormalCompletion2, _didIteratorError2, _iteratorError2, _iterator2, _step2, schedule, items, user, start, startTime, end, endTime, from, to, duration, hours, minutes, rule, endOfGeneration, endDate, events, _start3, _end3, _calendarEvent2, bookedSlot, customer, _start, _end, calendarEvent, _start2, _end2, days, holiday, holidayStart, holidayEnd, _calendarEvent;

        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (vm.isLvr) {
                  _context2.next = 3;
                  break;
                }

                $rootScope.$broadcast("auth_not_authorized");
                return _context2.abrupt("return");

              case 3:
                if (!($rootScope.$selectedCustomerId !== "$592e962acef2545fb62f1a99")) {
                  _context2.next = 6;
                  break;
                }

                $state.go("home");
                return _context2.abrupt("return");

              case 6:

                Notiflix.Loading.standard("Cliquez pour interrompre le chargement...");

                _context2.next = 9;
                return CustomersService.find({
                  filter: {
                    where: {},
                    fields: {
                      _id: true,
                      name: true,
                      operatorIds: true,
                      active: true
                    }
                  }
                });

              case 9:
                customers = _context2.sent;
                _context2.next = 12;
                return CustomListsService.getSelectArray("typeOfAccidentV2");

              case 12:
                typesOfAccidentList = _context2.sent;


                vm.rawOperatorData = [];
                _context2.next = 16;
                return OperatorsService.get();

              case 16:
                vm.operators = _context2.sent;
                index = 0;

              case 18:
                if (!(index < vm.operators.length)) {
                  _context2.next = 66;
                  break;
                }

                operator = vm.operators[index];

                if (!(vm.selectOperator && vm.selectOperator.length > 0)) {
                  _context2.next = 23;
                  break;
                }

                if (!(vm.selectOperator.indexOf(operator._id) < 0)) {
                  _context2.next = 23;
                  break;
                }

                return _context2.abrupt("continue", 63);

              case 23:

                operator.activatedTypeNames = operator.activatedTypes && operator.activatedTypes.length > 0 ? operator.activatedTypes.map(function (type) {
                  return typesOfAccidentList.find(function (t) {
                    return t.value === type;
                  }).name || type;
                }).join(", ") : "Tous";

                disabledCustomers = [];
                enabledCustomers = [];
                allCustomers = [];
                _iteratorNormalCompletion = true;
                _didIteratorError = false;
                _iteratorError = undefined;
                _context2.prev = 30;
                _iterator = customers[Symbol.iterator]();

              case 32:
                if (_iteratorNormalCompletion = (_step = _iterator.next()).done) {
                  _context2.next = 41;
                  break;
                }

                _customer = _step.value;

                if (_customer.active) {
                  _context2.next = 36;
                  break;
                }

                return _context2.abrupt("continue", 38);

              case 36:
                allCustomers.push(_customer);
                if (operator.disabledCustomersId && operator.disabledCustomersId.includes("$" + _customer._id)) {
                  disabledCustomers.push(_customer.name);
                } else {
                  enabledCustomers.push(_customer.name);
                }

              case 38:
                _iteratorNormalCompletion = true;
                _context2.next = 32;
                break;

              case 41:
                _context2.next = 47;
                break;

              case 43:
                _context2.prev = 43;
                _context2.t0 = _context2["catch"](30);
                _didIteratorError = true;
                _iteratorError = _context2.t0;

              case 47:
                _context2.prev = 47;
                _context2.prev = 48;

                if (!_iteratorNormalCompletion && _iterator.return) {
                  _iterator.return();
                }

              case 50:
                _context2.prev = 50;

                if (!_didIteratorError) {
                  _context2.next = 53;
                  break;
                }

                throw _iteratorError;

              case 53:
                return _context2.finish(50);

              case 54:
                return _context2.finish(47);

              case 55:

                operator.disabledCustomersNumber = disabledCustomers.length;
                operator.disabledCustomers = disabledCustomers.length ? disabledCustomers.join(", ") : "Aucun";

                operator.abledCustomersNumber = enabledCustomers.length;
                operator.enabledCustomers = enabledCustomers.length === allCustomers.length ? "Tous" : enabledCustomers.join(", ");

                operator.btEdit = {
                  text: '<i class="fa fa-edit"></i> Modifier',
                  color: "custom"
                };

                if (!operator.depaLimitHour || typeof operator.depaLimitHour !== "string") {
                  operator.depaLimitHour = "07:00 (par défaut)";
                }

                if (typeof operator.depaPriority !== "number") {
                  operator.depaPriority = "0 (par défaut)";
                }

                vm.rawOperatorData.push(operator);

              case 63:
                index++;
                _context2.next = 18;
                break;

              case 66:
                _context2.prev = 66;

                vm.log("refresh schedules", params);

                if (params && params.from && params.to) {
                  vm.from = params.from;
                  vm.to = params.to;
                }

                if (!vm.from || !vm.to) {
                  vm.from = moment().subtract(1, "months").startOf("month").toDate();
                  vm.to = moment().endOf("month").toDate();
                  vm.period = "previousMonth";
                }

                _context2.next = 72;
                return SchedulesService.load(null, false, null, null);

              case 72:
                schedules = _context2.sent;
                _context2.next = 75;
                return SchedulesService.get("mobile/holidays");

              case 75:
                holidays = _context2.sent;
                _context2.next = 78;
                return SchedulesService.post("mobile/bookedSlots", {
                  start: vm.from
                });

              case 78:
                bookedSlots = _context2.sent;


                vm.rawData = [];
                vm.rawClosedSlotData = [];
                eventsArray = [];
                eventsSlotArray = [];
                _iteratorNormalCompletion2 = true;
                _didIteratorError2 = false;
                _iteratorError2 = undefined;
                _context2.prev = 86;
                _iterator2 = schedules[Symbol.iterator]();

              case 88:
                if (_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done) {
                  _context2.next = 133;
                  break;
                }

                schedule = _step2.value;

                schedule.btEdit = {
                  text: '<i class="fa fa-edit"></i> Modifier',
                  color: "custom"
                };
                schedule.btDelete = {
                  text: '<i class="fa fa-trash"></i> Suppr.',
                  color: "custom-danger"
                };
                _context2.prev = 92;

                //vm.log('schedule', schedule)

                if (schedule.enabledCustomersId && schedule.enabledCustomersId.length > 0) {
                  items = customers.filter(function (item) {
                    return schedule.enabledCustomersId.includes("$" + item._id);
                  }).map(function (item) {
                    return item.name;
                  });

                  schedule.customers = items.join(", ");
                } else {
                  schedule.customers = "TOUS";
                }

                _context2.next = 96;
                return UsersService.getById(schedule.userId);

              case 96:
                user = _context2.sent;

                if (user) {
                  _context2.next = 102;
                  break;
                }

                vm.log("user not found", schedule.userId);
                return _context2.abrupt("continue", 130);

              case 102:
                if (!(vm.selectOperator && vm.selectOperator.length > 0)) {
                  _context2.next = 105;
                  break;
                }

                if (!(vm.selectOperator.indexOf(user._id) < 0)) {
                  _context2.next = 105;
                  break;
                }

                return _context2.abrupt("continue", 130);

              case 105:
                _context2.next = 107;
                return CustomersService.getNameById(schedule.customerId);

              case 107:
                schedule.customerName = _context2.sent;


                // FIXME : load lvr user
                //schedule.userName = await UsersService.getNameById(schedule.userId)

                schedule.operatorId = user._id;
                _context2.next = 111;
                return UsersService.getName(user);

              case 111:
                schedule.operatorName = _context2.sent;


                //vm.log('schedule.userName',schedule.userName)

                start = moment(schedule.fromDate);
                startTime = schedule.startTime.split(":");
                end = moment(schedule.fromDate);
                endTime = schedule.endTime.split(":");

                // calculate total duration

                from = moment().set({
                  hour: startTime[0],
                  minute: startTime[1],
                  second: 0,
                  millisecond: 0
                });
                to = moment().set({
                  hour: endTime[0],
                  minute: endTime[1],
                  second: 0,
                  millisecond: 0
                });
                duration = moment.duration(to.diff(from));
                // duration in hours

                hours = parseInt(duration.asHours());
                // duration in minutes

                minutes = parseInt(duration.asMinutes()) % 60;

                if (hours == 0) {
                  schedule.nbDays = minutes + " minute(s)";
                } else {
                  if (minutes == 0) {
                    schedule.nbDays = hours + " heure(s)";
                  } else {
                    schedule.nbDays = hours + " heure(s) et " + minutes + " minute(s)";
                  }
                }

                if (!schedule.rrule) {
                  start = start.set({
                    hour: startTime[0],
                    minute: startTime[1],
                    second: 0,
                    millisecond: 0
                  });

                  end = end.set({
                    hour: endTime[0],
                    minute: endTime[1],
                    second: 0,
                    millisecond: 0
                  });

                  eventsArray.push({
                    title: schedule.operatorName,
                    start: start,
                    end: end,
                    editable: false,
                    backgroundColor: user.calendarColor ? user.calendarColor : "#bccad6"
                  });
                } else {
                  //console.log('schedule.rrule', schedule.rrule)

                  rule = RRule.rrulestr(schedule.rrule.rrule, {
                    dtstart: new Date(schedule.fromDate)
                  });


                  schedule.rruleDescription = schedule.rrule.description;
                  schedule.rruleUntil = schedule.rrule.until;

                  //console.log('rule', rule)

                  rule.dtstart = new Date(schedule.fromDate);

                  endOfGeneration = new Date();


                  endOfGeneration.setDate(endOfGeneration.getDate() + 180);

                  if (schedule.endDate) {
                    endDate = new Date(schedule.endDate);


                    if (endDate.getTime() < endOfGeneration.getTime()) {
                      endOfGeneration = endDate;
                    }
                  }

                  events = rule.between(new Date(), endOfGeneration);

                  //console.log('events', events)

                  for (index = 0; index < events.length; index++) {
                    _start3 = moment(events[index]);


                    _start3 = _start3.set({
                      hour: startTime[0],
                      minute: startTime[1],
                      second: 0,
                      millisecond: 0
                    });

                    _end3 = moment(events[index]);


                    _end3 = _end3.set({
                      hour: endTime[0],
                      minute: endTime[1],
                      second: 0,
                      millisecond: 0
                    });

                    _calendarEvent2 = {
                      title: schedule.operatorName,
                      start: _start3,
                      end: _end3,
                      editable: false,
                      backgroundColor: user.calendarColor ? user.calendarColor : "#bccad6",
                      eventId: schedule._id,
                      inactive: false
                    };


                    eventsArray.push(_calendarEvent2);
                  }
                }

                vm.rawData.push(schedule);
                _context2.next = 130;
                break;

              case 126:
                _context2.prev = 126;
                _context2.t1 = _context2["catch"](92);

                console.error(_context2.t1);

                Notiflix.Notify.failure("Une erreur est survenue sur l'object :" + schedule._id);

              case 130:
                _iteratorNormalCompletion2 = true;
                _context2.next = 88;
                break;

              case 133:
                _context2.next = 139;
                break;

              case 135:
                _context2.prev = 135;
                _context2.t2 = _context2["catch"](86);
                _didIteratorError2 = true;
                _iteratorError2 = _context2.t2;

              case 139:
                _context2.prev = 139;
                _context2.prev = 140;

                if (!_iteratorNormalCompletion2 && _iterator2.return) {
                  _iterator2.return();
                }

              case 142:
                _context2.prev = 142;

                if (!_didIteratorError2) {
                  _context2.next = 145;
                  break;
                }

                throw _iteratorError2;

              case 145:
                return _context2.finish(142);

              case 146:
                return _context2.finish(139);

              case 147:

                vm.events = eventsArray;

                index = 0;

              case 149:
                if (!(index < bookedSlots.length)) {
                  _context2.next = 196;
                  break;
                }

                bookedSlot = bookedSlots[index];
                _context2.next = 153;
                return UsersService.getById(bookedSlot.slot.operatorId);

              case 153:
                user = _context2.sent;
                _context2.next = 156;
                return UsersService.getName(user);

              case 156:
                user.name = _context2.sent;
                _context2.next = 159;
                return CustomersService.getById(bookedSlot.customerId);

              case 159:
                customer = _context2.sent;

                if (user) {
                  _context2.next = 165;
                  break;
                }

                vm.log("user not found", bookedSlot.slot.operatorId);
                return _context2.abrupt("continue", 193);

              case 165:
                if (!(vm.selectOperator && vm.selectOperator.length > 0)) {
                  _context2.next = 168;
                  break;
                }

                if (!(vm.selectOperator.indexOf(user._id) < 0)) {
                  _context2.next = 168;
                  break;
                }

                return _context2.abrupt("continue", 193);

              case 168:
                _start = moment(bookedSlot.slot.start);
                _end = moment(bookedSlot.slot.end);


                if (bookedSlot.slot && bookedSlot.slot.start) {
                  bookedSlot.slotStart = bookedSlot.slot.start;
                }
                if (bookedSlot.slot && bookedSlot.slot.end) {
                  bookedSlot.slotEnd = bookedSlot.slot.end;
                }

                calendarEvent = {
                  title: bookedSlot.status === "Fermé" ? user.firstName + " - Fermé : " + bookedSlot.note : user.firstName + " - " + customer.name,
                  start: _start,
                  end: _end,
                  editable: false,
                  backgroundColor: user.calendarColor ? user.calendarColor : "#bccad6",
                  inactive: bookedSlot.status !== "Effectué" && bookedSlot.status !== "Programmé" ? true : false
                };


                eventsSlotArray.push(calendarEvent);

                if (!(bookedSlot.status === "Fermé")) {
                  _context2.next = 193;
                  break;
                }

                bookedSlot.btEdit = {
                  text: '<i class="fa fa-edit"></i> Modifier',
                  color: "custom"
                };
                bookedSlot.btDelete = {
                  text: '<i class="fa fa-trash"></i> Suppr.',
                  color: "custom-danger"
                };

                if (!(bookedSlot.slot && bookedSlot.slot.operatorId)) {
                  _context2.next = 192;
                  break;
                }

                _context2.next = 180;
                return OperatorsService.getById(bookedSlot.slot.operatorId);

              case 180:
                bookedSlot.operator = _context2.sent;


                vm.log(bookedSlot.slot.operatorId, " operator=", bookedSlot.operator);

                _context2.next = 184;
                return OperatorsService.getNameById(bookedSlot.slot.operatorId);

              case 184:
                bookedSlot.operatorName = _context2.sent;
                _start2 = moment(bookedSlot.slot.start);
                _end2 = moment(bookedSlot.slot.end);
                duration = moment.duration(_end2.diff(_start2));
                // duration in days

                days = parseInt(duration.asDays());
                // duration in hours

                hours = parseInt(duration.asHours()) % 24;
                // duration in minutes

                minutes = parseInt(duration.asMinutes()) % 60;

                if (days == 0) {
                  if (hours == 0) {
                    bookedSlot.nbDays = minutes + " minute(s)";
                  } else {
                    if (minutes == 0) {
                      bookedSlot.nbDays = hours + " heure(s)";
                    } else {
                      bookedSlot.nbDays = hours + " heure(s) et " + minutes + " minute(s)";
                    }
                  }
                } else {
                  if (hours == 0) {
                    if (minutes == 0) {
                      bookedSlot.nbDays = days + " jour(s)";
                    } else {
                      bookedSlot.nbDays = days + " jour(s) et " + minutes + " minute(s)";
                    }
                  } else {
                    if (minutes == 0) {
                      bookedSlot.nbDays = days + " jour(s) et " + hours + " heure(s)";
                    } else {
                      bookedSlot.nbDays = days + " jour(s), " + hours + " heure(s) et " + minutes + " minute(s)";
                    }
                  }
                }

              case 192:
                vm.rawClosedSlotData.push(bookedSlot);

              case 193:
                index++;
                _context2.next = 149;
                break;

              case 196:

                vm.eventsSlot = eventsSlotArray;

                for (index = 0; index < holidays.length; index++) {
                  holiday = holidays[index];
                  holidayStart = moment(holiday.start);
                  holidayEnd = moment(holiday.end);
                  _calendarEvent = {
                    title: holiday.name,
                    start: holidayStart,
                    end: holidayEnd,
                    editable: false,
                    backgroundColor: "#fff",
                    inactive: holiday.type == "public" && holiday.name != "Lundi de Pentecôte" ? true : false
                  };


                  eventsArray.push(_calendarEvent);
                  eventsSlotArray.push(_calendarEvent);
                }

                Notiflix.Loading.remove();

                $timeout(function () {
                  _this.needToBeUpdate = true;
                });
                _context2.next = 207;
                break;

              case 202:
                _context2.prev = 202;
                _context2.t3 = _context2["catch"](66);

                Notiflix.Notify.failure("Une erreur est survenue au chargement des données");

                console.error(_context2.t3);
                Notiflix.Loading.remove();

              case 207:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, _this, [[30, 43, 47, 55], [48,, 50, 54], [66, 202], [86, 135, 139, 147], [92, 126], [140,, 142, 146]]);
      }));

      return function (_x2) {
        return _ref2.apply(this, arguments);
      };
    }();

    vm.refreshCalendar = function () {
      $timeout(function () {
        vm.needCalendarToBeUpdate = true;
      }, 0);
    };

    vm.editOperator = function (row) {
      console.log(row);
      vm.log("row=", row);
      ModalService.open("users/user", { _id: row._id }).then(function (_id) {
        vm.refresh();
      });
    };

    vm.delete = function () {
      var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(row) {
        var deleteSchedule;
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return swal({
                  title: "Voulez-vous supprimer le cr\xE9neau de " + row.operatorName + " ?",

                  icon: "warning",
                  dangerMode: true,

                  buttons: ["Annuler", "Valider"]
                });

              case 2:
                deleteSchedule = _context3.sent;

                if (!deleteSchedule) {
                  _context3.next = 7;
                  break;
                }

                console.log("need to delete this schedule", row);
                _context3.next = 7;
                return SchedulesService.deleteById(row._id).then(function () {
                  Notiflix.Notify.success("La suppression a réussi");
                  vm.refresh();
                });

              case 7:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, _this);
      }));

      return function (_x3) {
        return _ref3.apply(this, arguments);
      };
    }();

    vm.columnDefs0 = [AgGridService.text("operatorName", "Conseiller/ère"), AgGridService.text("customers", "Client(s)"), AgGridService.date("fromDate", "Du"), AgGridService.text("startTime", "Début"), AgGridService.text("endTime", "Fin"), AgGridService.text("rruleDescription", "Récurrence"), AgGridService.date("rruleUntil", "Jusqu'à"), AgGridService.text("nbDays", "Durée"), AgGridService.text("name", "Description"), AgGridService.text("note", "Commentaire")];

    vm.columnDefs2 = [AgGridService.text("lastName", "Nom"), AgGridService.text("firstName", "Prénom"), AgGridService.number("depaPriority", "Priorité DEPA"), AgGridService.text("depaLimitHour", "Heure limite de prise de RDV DEPA"), AgGridService.bool("depaSlidingSlots", "Avec créneaux glissants (1 heure)", false, {
      className: "col-xs-12 col-sm-3"
    }), AgGridService.number("disabledCustomersNumber", "Nombre de clients désactivés"), AgGridService.number("disabledCustomers", "Clients désactivés"), AgGridService.text("activatedTypeNames", "Types de sinistre activés"), AgGridService.number("abledCustomersNumber", "Nombre de clients activés"), AgGridService.number("enabledCustomers", "Clients activés")];

    vm.columnDefs3 = [AgGridService.text("operatorName", "Conseiller/ère", 110), AgGridService.date("slotStart", "Début (date)", 100), AgGridService.hour("slotStart", "Début (heure)", 85), AgGridService.date("slotEnd", "Fin (jour)", 100), AgGridService.hour("slotEnd", "Fin (heure)", 85), AgGridService.text("nbDays", "Durée", 85), AgGridService.text("note", "Description", 85)];

    if (vm.isSuper) {
      vm.columnDefs0.unshift(AgGridService.group("Actions", [AgGridService.button("btEdit", "Modifier", vm.edit, this, {
        width: 90
      }), AgGridService.button("btDelete", "Suppr.", vm.delete, this, {
        width: 90,
        columnGroupShow: "open"
      })]));
      vm.columnDefs2.unshift(AgGridService.group("Actions", [AgGridService.button("btEdit", "Modifier", vm.editOperator, this, {
        width: 90
      })]));
    }

    if (vm.isSuper) {
      vm.columnDefs3.unshift(AgGridService.group("Actions", [AgGridService.button("btEdit", "Modifier", vm.editClosedSlot, this, {
        width: 90
      }), AgGridService.button("btDelete", "Suppr.", vm.deleteClosedSlot, this, {
        width: 90,
        columnGroupShow: "open"
      })]));
    }

    vm.refresh();
  }
})();